import { PropsWithChildren } from 'react';
import { Navigate } from 'react-router';

import { Loader } from '~shared/ui/loader';

import { isAuthorisedAtom } from '@breezeventures/web-ph-client-auth/model';
import { useAtomValue } from 'jotai';

import { useUserInfo } from '../api';
import { getDefaultRouteByRole } from '../lib';

export const AnonymousGuard = ({ children }: PropsWithChildren) => {
  const isAuthorised = useAtomValue(isAuthorisedAtom);
  const userInfoQuery = useUserInfo({
    enabled: isAuthorised,
  });

  if (!isAuthorised) {
    return children;
  }

  if (userInfoQuery.data && isAuthorised) {
    return <Navigate to={getDefaultRouteByRole(userInfoQuery.data)} replace />;
  }

  return <Loader />;
};
